import { render } from "./Egresos.vue?vue&type=template&id=179c8c84&scoped=true"
import script from "./Egresos.vue?vue&type=script&lang=js"
export * from "./Egresos.vue?vue&type=script&lang=js"

import "./Egresos.vue?vue&type=style&index=0&id=179c8c84&scoped=true&lang=css"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179c8c84"]])

export default __exports__